<template>
  <b-form-group :label="properties.label">
    <b-select
      size="sm"
      v-model="propertyValue"
      :options="properties.options"
    ></b-select>
  </b-form-group>
</template>

<script>
export default {
  name: "TextAreaPropertyType",
  props: ["properties", "property", "value", "options"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    }
  }
};
</script>
